import { render, staticRenderFns } from "./ItemPickV2.vue?vue&type=template&id=2f2f873d&scoped=true"
import script from "./ItemPickV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemPickV2.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f873d",
  null
  
)

export default component.exports